import { combineReducers } from 'redux'

import accountActivity from './accountActivity'
import applications from './applications'
import attendance from './attendance'
import authentication from './authentication'
import boosts from './boosts'
import campaigns from './campaigns'
import campaignPartners from './campaignPartners'
import categories from './categories'
import donations from './donations'
import donationConfirmations from './donationConfirmations'
import donationSubscriptions from './donationSubscriptions'
import emailActivity from './emailActivity'
import emp501 from './emp501'
import faqs from './faqs'
import feedback from './feedback'
import followings from './followings'
import instagramBioLinks from './instagramBioLinks'
import levelUp from './levelUp'
import messaging from './messaging'
import notifications from './notifications'
import opportunities from './opportunities'
import organisations from './organisations'
import ozow from './ozow'
import payments from './payments'
import people from './people'
import personalGoals from './personalGoals'
import platformEvents from './platformEvents'
import platformSubscriptions from './platformSubscriptions'
import places from './places'
import purchaseRequestBatches from './purchaseRequestBatches'
import purchaseRequests from './purchaseRequests'
import search from './search'
import stats from './stats'
import stories from './stories'
import teams from './teams'
import teamGroups from './teamGroups'
import terminations from './terminations'
import uif from './uif'
import shiftLogEntries from './shiftLogEntries'

//
// Dgmt sagas
//
import dgmt from './dgmt'

//
// Sef sagas
//
import sef from './sef'
import sefForms from './sefForms'

//
// Ace sagas
//
import ace from './ace'

export default combineReducers({
  accountActivity,
  applications,
  attendance,
  authentication,
  boosts,
  campaigns,
  campaignPartners,
  categories,
  donations,
  donationConfirmations,
  donationSubscriptions,
  emailActivity,
  emp501,
  faqs,
  feedback,
  followings,
  instagramBioLinks,
  levelUp,
  messaging,
  notifications,
  opportunities,
  organisations,
  ozow,
  payments,
  people,
  places,
  personalGoals,
  platformEvents,
  platformSubscriptions,
  purchaseRequestBatches,
  purchaseRequests,
  search,
  stats,
  stories,
  teams,
  teamGroups,
  terminations,
  uif,
  shiftLogEntries,
  //
  // dgmt sagas
  //
  dgmt,
  //
  // sef sagas
  //
  sef,
  sefForms,
  //
  // ace sagas
  //
  ace
})
